<app-ion-common-header [id]="headerId" (backHeader)="backPage()" (focusHeader)="shownContent()" [title]="titlePage" start="{{startStage}}" end="{{endStage}}"></app-ion-common-header>

<ion-content [attr.aria-hidden]="ariaHidden" [style.visibility]="ariaHidden ? 'hidden' : 'visible'">
  
<app-ion-common-label class="document-type-label1" labelStyle="display-rg" 
  labelDescription="Qual número em {{ addressName }}?">
</app-ion-common-label>

<div class="conent-center conent-center--mrt-lg">
  <form [formGroup]="addressNumberForm" (ngSubmit)="submitForm($event)">
      <app-ion-common-input
        [fieldValue]="number"
        [placeholder]="placeholder" 
        [error]="error" 
        [id]="idComponentName"
        [textError]="textError"
        maxLength="5"
        (textChange)="number=$event; errorMessage();"
        type="text"
        [idLabel]="idLabel"
        [label]="label"
        [replaceStrTo]="'documentWithSpaceBar'"
        [disabled]="!this.edit"
        name="numberAddress"
        formControlName="numberAddress"
        ngDefaultControl>
      </app-ion-common-input>
    </form>
  </div>

  <app-ion-common-button class="hidden" [ngClass]="{'hidden': !buttonEnable || number?.length === 0}" [attr.aria-hidden]="!buttonEnable"
  label="Continuar" (clickButton)="clickNext();"></app-ion-common-button>

</ion-content>

